module.exports = __webpack_public_path__ + "assets/favicons/favicon-32x32.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=assets/favicons/[name].[ext]!./client/app/assets/favicons/favicon-32x32.png
// module id = 1237
// module chunks = 1